import {
  VisaDocumentTransactionListItemModel,
  VisaDocumentTransactionListModel,
} from 'api-hooks/visa-document';
import { NavigationRoutes } from 'common/constants';
import { string2money } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import useDate from 'hooks/use-date';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import { SectionContainer } from 'legacy-modules/approval/approval/components/style';
import {
  CardContainer,
  HalfContainer,
  TableContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export interface VisaDocumentTransactionListItemProps {
  data: VisaDocumentTransactionListModel;
}

export default function VisaDocumentTransactionListItem(
  props: VisaDocumentTransactionListItemProps,
) {
  const { t } = useTranslation();

  const salesColumns: IColumn<VisaDocumentTransactionListItemModel>[] = [
    {
      header: t('common:invoice_number'),
      accessorKey: 'number',
    },
    {
      header: t('common:total_price'),
      accessorKey: 'total',
      textAlign: 'right',
      cell({ row }) {
        return string2money(row.original.total);
      },
    },
  ];

  const purchasesColumns: IColumn<VisaDocumentTransactionListItemModel>[] = [
    {
      header: t('common:order_number'),
      accessorKey: 'number',
    },
    {
      header: t('common:total_price'),
      accessorKey: 'total',
      textAlign: 'right',
      cell({ row }) {
        return string2money(row.original.total);
      },
    },
  ];

  const formatDate = useDate();

  const documentSalePermission = useGetCrudPermission('document-sales');
  const documentPurchasePermission = useGetCrudPermission('document-purchases');
  return (
    <>
      <Text variant="LabelSmall">
        {t('common:transaction_at')}:{' '}
        {formatDate(props.data.transactionAt, 'dd MMM yyyy')}
      </Text>
      <Separator gap={10} />
      <SectionContainer
        style={{
          alignItems: 'stretch',
        }}
      >
        <HalfContainer>
          <CardContainer>
            <Text variant="LabelSmall">Sales</Text>
            <Separator gap={10} />
            <TableContainer
              style={{
                minHeight: 400,
                maxHeight: 400,
              }}
            >
              <TableComponent
                rowLink={(row) => {
                  if (!documentSalePermission.view) return undefined;
                  return {
                    pathname: NavigationRoutes.TravelDocumentSalesView,
                    query: { id: row.original.id },
                  };
                }}
                columns={salesColumns}
                data={props.data.sales}
              />
            </TableContainer>
          </CardContainer>
        </HalfContainer>
        <HalfContainer>
          <CardContainer>
            <Text variant="LabelSmall">Order</Text>
            <Separator gap={10} />
            <TableContainer
              style={{
                minHeight: 400,
                maxHeight: 400,
                overflow: 'auto',
              }}
            >
              <TableComponent
                rowLink={(row) => {
                  if (!documentPurchasePermission.view) return undefined;
                  return {
                    pathname: NavigationRoutes.DocumentPurchasesView,
                    query: { id: row.original.id },
                  };
                }}
                columns={purchasesColumns}
                data={props.data.purchases}
              />
            </TableContainer>
          </CardContainer>
        </HalfContainer>
      </SectionContainer>
    </>
  );
}
